function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import RdfResourceImpl from "./index.mjs";
export function createFactory(mixins, baseInitializer) {
  const fullFactory = (pointer, initializer, {
    factory = RdfResourceImpl.factory,
    additionalMixins = []
  } = {}) => {
    return factory.createEntity(pointer, [...mixins, ...additionalMixins], {
      initializer: _objectSpread(_objectSpread({}, baseInitializer), initializer || {})
    });
  };

  const curriedNamedFactory = (id, initializer, {
    factory = RdfResourceImpl.factory,
    additionalMixins = []
  } = {}) => {
    return (graph, overrideFactory = factory) => {
      const term = typeof id === 'string' ? graph.namedNode(id) : graph.node(id);
      return overrideFactory.createEntity(term, [...mixins, ...additionalMixins], {
        initializer: _objectSpread(_objectSpread({}, baseInitializer), initializer || {})
      });
    };
  };

  const curriedBlankFactory = (initializer, {
    factory = RdfResourceImpl.factory,
    additionalMixins = []
  } = {}) => {
    return (graph, overrideFactory = factory) => overrideFactory.createEntity(graph.blankNode(), [...mixins, ...additionalMixins], {
      initializer: _objectSpread(_objectSpread({}, baseInitializer), initializer || {})
    });
  };

  return (first, second, third) => {
    if (typeof first === 'object' && 'term' in first) {
      return fullFactory(first, second, third);
    }

    if (typeof first === 'object' && first.termType === 'NamedNode' || typeof first === 'string') {
      return curriedNamedFactory(first, second, third);
    }

    return curriedBlankFactory(first, second);
  };
}